<template>
  <div>
    <div
      class="tw-w-full tw-mt-4 tw-p-4 tw-bg-orange-250 tw-rounded-lg tw-shadow tw-border-orange-350 tw-border"
      data-cy="account-verification-notification"
    >
      <div class="tw-flex">
        <div class="tw-py-3">
          <SvgIcon
            name="exclamation-warning-solid-icon-alt"
            class="tw-mr-3 tw-w-5 tw-h-5"
          />
        </div>
        <div>
          <p class="tw-mb-1 tw-font-medium tw-text-gray-800 tw-mt-2 tw-text-xl">
            Verify Your account.
          </p>
          <p class="tw-text-gray-700 tw-mt-4 tw-text-xl">
            To finish setting up this Leave Dates account, we just need to make
            sure that the email address is yours. Please click the link in the
            verification email to verify your account.
          </p>
          <button
            class="tw-px-4 tw-py-3 tw-rounded-full tw-text-orange-700 tw-bg-transparent tw-border-2 tw-shadow-lg tw-border-gray-440 tw-mt-4 tw-text-xl tw-font-semibold hover:none hover:tw-bg-transparent"
            @click="resendVerificationCode"
          >
            Resend
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccountVerification',

  methods: {
    async resendVerificationCode() {
      try {
        await this.$http.post('resend-verification')

        this.success('Your verification code has been sent.')
      } catch (e) {
        this.error('We are having some issues to send the verification code.')
      }
    },
  },
}
</script>
